import { render, staticRenderFns } from "./taskManualView.vue?vue&type=template&id=a7ca65d4&"
import script from "./taskManualView.vue?vue&type=script&lang=js&"
export * from "./taskManualView.vue?vue&type=script&lang=js&"
import style0 from "./taskManualView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports